import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuthContext } from "@hooks/useAuthContext";

interface PrivateRouteProps {
    children: ReactNode
}

export function PrivateRoute(props: PrivateRouteProps) {
    const { children } = props;
    const { isUserAuthenticated } = useAuthContext();
    const location = useLocation();

    if (!isUserAuthenticated) {
        localStorage.setItem("pathname", location.pathname);
        localStorage.setItem("search", location.search);
        return <Navigate to="/" replace />;
    }

    return children;
}